import { GeneralAPI } from '../apis/GeneralAPI'
import { first } from 'lodash'
import Header from '../components/Header'
import Footer from '../components/Footer'
import HomePageV2 from '../components/HomePageV2'

export default function Home({ data, reviews }) {
    return (
        <>
            <Header meta={data?.yoast_head} />
            <HomePageV2 reviews={reviews} />
            <Footer />
        </>
    )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/home')
    const data = page ? page[0] : {}
    const { acf: reviewsACF = {} } =
        first(await GeneralAPI.getPageBySlug('reviews')) || {}
    const reviews = reviewsACF?.reviews?.length > 0 ? reviewsACF.reviews : []

    return {
        props: {
            data,
            reviews,
        },
        revalidate: 10, // In seconds
    }
}
